import { saveData } from "../../../main/modules/main/save-data.js";
import { useMainStore } from "../../../main/store/mainStore.js";

export const trackPubNubMessageData = ({ message }) => {
  const lastCaseID =
    message?.message?.payload?.caseId ||
    message?.message?.payload?.case?.id ||
    null;

  const lastPubNubMessageReceivedTime = Date.now();

  const lastPubNubMessageTimetoken = message.timetoken;

  const mainStore = useMainStore();

  if (lastCaseID) {
    mainStore.lastCaseID = lastCaseID;
  }

  mainStore.lastPubNubMessageReceivedTime = lastPubNubMessageReceivedTime;

  if (lastPubNubMessageTimetoken) {
    saveData({
      data: ["lastPubNubMessageTimetoken", lastPubNubMessageTimetoken],
      store: mainStore,
    });
  }
};
